import { ArrowTopRightCircle, Globe2, PaintTool } from "@layer/icons";
import type { CommandGroupType } from "@layer/utils/lib/commands";
import { THEMES } from "@/lib/constants/themes";
import { type Locale, locales } from "../locale/config";

export const defaultCommands: CommandGroupType[] = [
	{
		id: "navigation",
		items: [
			{ id: "home", icon: ArrowTopRightCircle, href: "/", hotkey: "H" },
			{
				id: "campaigns",
				icon: ArrowTopRightCircle,
				href: "/campaigns",
				hotkey: "C",
			},
			{
				id: "cohorts",
				icon: ArrowTopRightCircle,
				href: "/campaigns",
				hotkey: "CO",
			},
			{
				id: "merchants",
				icon: ArrowTopRightCircle,
				href: "/merchants",
				hotkey: "M",
			},
			{
				id: "clientProfile",
				icon: ArrowTopRightCircle,
				href: "/client-profile",
				hotkey: "CP",
			},
		],
	},
	{
		id: "quickActions",
		items: [
			{
				id: "theme",
				icon: PaintTool,
				hotkey: "CT",
				items: THEMES.map((theme) => ({
					id: theme.value,
					icon: theme.icon,
				})),
			},
			{
				id: "language",
				icon: Globe2,
				hotkey: "L",
				items: locales.map((locale: Locale) => ({
					id: locale,
				})),
			},
		],
	},
];
